import { __awaiter } from "tslib";
import axios from "axios";
import { CID } from "multiformats/cid";
// TODO remove this, the method to add to IPFS should come from the adapter settings instead of being hardcoded
const stage = 
// eslint-disable-next-line no-nested-ternary
(process.env.REACT_APP_STAGE || "dev") === "prod"
    ? "prod"
    : process.env.REACT_APP_STAGE === "preprod"
        ? "preprod"
        : "dev";
const defaultApiUrl = `https://${stage === "prod" ? "" : "dev."}api.civic.com`;
const pathSuffix = stage === "prod" ? "" : `-${stage}`;
const pinningServiceBaseUrl = process.env.REACT_APP_PINNING_SERVICE_URL
    ? process.env.REACT_APP_PINNING_SERVICE_URL
    : `${defaultApiUrl}/pinning-service${pathSuffix}`;
class IPFSStorageAdapter {
    // eslint-disable-next-line class-methods-use-this
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            // NOP
        });
    }
    // eslint-disable-next-line class-methods-use-this
    has(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                CID.parse(contentId); // Throws an exception if CID is invalid and avoids propagation to cat method.
                return true;
            }
            catch (_a) {
                return false;
            }
        });
    }
    // TODO remove this, the method to add to IPFS should come from the adapter settings instead of being hardcoded
    // eslint-disable-next-line class-methods-use-this
    set(_contentId, content) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.post(`${pinningServiceBaseUrl}/add`, {
                data: typeof content === "string" ? JSON.parse(content) : content,
            });
            return response.data;
        });
    }
    // eslint-disable-next-line class-methods-use-this
    get(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            CID.parse(contentId); // Throws an exception if CID is invalid and avoids propagation to cat method.
            const response = yield axios.get(`https://civic.infura-ipfs.io/ipfs/${contentId}`);
            if (typeof response.data === "string") {
                return response.data;
            }
            return JSON.stringify(response.data);
        });
    }
}
export default IPFSStorageAdapter;
